import dayjs from 'dayjs';
import { getAllInvoices } from 'lib/api/dashboard';
import GlobalSearcher, { Filter } from 'lib/common/GlobalSearcher';
import HeaderWithActions, {
  CustomButtonProps,
} from 'lib/designSystem/HeaderWithActions';
import TableWithPagination from 'lib/designSystem/TableWithPagination';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

const LastInvoices = () => {
  const dispatch = useDispatch();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const startDateDefault = dayjs().subtract(1, 'month');
  const endDateDefault = dayjs();
  const [endDate, setEndDate] = useState(endDateDefault);
  const [startDate, setStartDate] = useState(startDateDefault);
  const [folio, setFolio] = useState('');
  const [businessIdentifier, setBusinessIdentifier] = useState('');
  const [businessName, setBusinessName] = useState('');
  const [stakeholderIdentifier, setStakeholderIdentifier] = useState('');
  const [stakeholderName, setStakeholderName] = useState('');
  const PAGE_SIZE = 10;
  const [pagination, setPagination] = useState({
    page: 0,
    pageSize: PAGE_SIZE,
    total: 0,
    totalPages: 0,
  });

  const generateQuery = ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }) => {
    let query = '';
    if (startDate) query += `startDate=${startDate}&`;
    if (endDate) query += `endDate=${endDate}&`;
    if (folio) query += `folio=${folio}&`;
    if (businessIdentifier)
      query += `businessIdentifier=${businessIdentifier}&`;
    if (stakeholderIdentifier)
      query += `stakeholderIdentifier=${stakeholderIdentifier}&`;
    if (stakeholderName) query += `stakeholderName=${stakeholderName}&`;
    if (businessName) query += `businessName=${businessName}&`;
    if (page) query += `page=${page}&pageSize=${pageSize}`;
    return query;
  };

  const searchInvoices = async ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }) => {
    setLoading(true);
    try {
      const query = generateQuery({ page, pageSize });
      const response = await getAllInvoices(dispatch, query);
      setInvoices(response.data);
      setPagination(response.pagination);
    } catch (error) {
      alert('No tienes permisos para ver las facturas');
    }
    setLoading(false);
  };

  const triggerSearch = async () => {
    await searchInvoices({ page: 0, pageSize: PAGE_SIZE });
  };

  const filters: Filter[] = [
    {
      type: 'text',
      label: 'Folio',
      value: folio,
      setter: setFolio,
    },
    {
      type: 'date',
      label: 'Fecha',
      value: startDate,
      setter: setStartDate,
      dateKey: 'startDate',
      pairKey: 'endDate',
    },
    {
      type: 'date',
      label: 'Fecha',
      value: endDate,
      setter: setEndDate,
      dateKey: 'endDate',
      pairKey: 'startDate',
    },
    {
      label: 'Nombre emisor',
      type: 'autocomplete',
      value: businessName,
      key: 'businessName',
      setter: setBusinessName,
    },
    {
      type: 'text',
      label: 'Rut emisor',
      value: businessIdentifier,
      setter: setBusinessIdentifier,
    },
    {
      label: 'Nombre receptor',
      type: 'autocomplete',
      value: stakeholderName,
      key: 'stakeholderName',
      setter: setStakeholderName,
    },
    {
      type: 'text',
      label: 'Rut receptor',
      value: stakeholderIdentifier,
      setter: setStakeholderIdentifier,
    },
  ];

  const buttons: CustomButtonProps[] = [
    {
      name: 'Buscar',
      color: 'primary',
      action: () => {},
      customButton: (
        <GlobalSearcher
          filters={filters}
          triggerSearch={triggerSearch}
          dispatch={dispatch}
        />
      ),
    },
  ];

  useEffect(() => {
    void searchInvoices({ page: 0, pageSize: PAGE_SIZE });
  }, []);

  return (
    <div>
      <HeaderWithActions
        title="Acá puedes buscar todas las facturas de tus enrolados"
        variant="body1"
        buttons={buttons}
      />
      <TableWithPagination
        dataHeaders={[
          { key: 'folio', label: 'Folio' },
          { key: 'businessName', label: 'Nombre Emisor' },
          { key: 'businessIdentifier', label: 'Rut Emisor' },
          { key: 'stakeholderName', label: 'Nombre receptor' },
          { key: 'stakeholderIdentifier', label: 'Rut receptor' },
          { key: 'issuedDate', label: 'Emisión', type: 'eight-days-date' },
          {
            key: 'confirmDate',
            label: 'Confirmación',
            type: 'date-colored-ok',
          },
          { key: 'cancelDate', label: 'Reclamo', type: 'date-colored' },
          { key: 'amount', label: 'Monto', type: 'money' },
          { key: 'status', label: 'Estado', type: 'cession' },

          { key: 'cessionaries', label: 'Cesionario', type: 'cessionaries' },
        ]}
        exportToFile="xlsx"
        data={invoices}
        loading={loading}
        setData={setInvoices}
        searchData={searchInvoices}
        setPagination={setPagination}
        pagination={pagination}
      />
    </div>
  );
};

export default LastInvoices;
